import { Controller } from "@hotwired/stimulus"

// Self-storage revenue calculator. Recomputes results live as inputs change.
export default class extends Controller {
  static targets = [
    "units", "rent", "occupancy", "opex", "occLabel", "opexLabel",
    "occupied", "monthly", "annual", "noi", "revpau"
  ]

  connect() { this.compute() }

  compute() {
    const units = Math.max(0, this.#num(this.unitsTarget))
    const rent = Math.max(0, this.#num(this.rentTarget))
    const occ = Math.min(100, Math.max(0, this.#num(this.occupancyTarget)))
    const opex = Math.min(100, Math.max(0, this.#num(this.opexTarget)))

    if (this.hasOccLabelTarget) this.occLabelTarget.textContent = Math.round(occ)
    if (this.hasOpexLabelTarget) this.opexLabelTarget.textContent = Math.round(opex)

    const occupied = Math.round(units * occ / 100)
    const monthly = occupied * rent
    const annual = monthly * 12
    const noi = annual * (1 - opex / 100)
    const revpau = units > 0 ? annual / units : 0

    this.occupiedTarget.textContent = occupied.toLocaleString()
    this.monthlyTarget.textContent = this.#money(monthly)
    this.annualTarget.textContent = this.#money(annual)
    this.noiTarget.textContent = this.#money(noi)
    this.revpauTarget.textContent = this.#money(revpau)
  }

  #num(el) { const v = parseFloat(el.value); return Number.isNaN(v) ? 0 : v }
  #money(n) {
    return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
  }
}
